import { LoginService } from './../../../core/services/login.service';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
const deleteDentalSupplierAddressesByPkMutation = gql`mutation delete_dental_supplier_addresses_by_pk($id: uuid!){
  delete_dental_supplier_addresses_by_pk(id: $id){
    id
  }
}`;

const deleteDentalProfessionalAddressesByPkMutation = gql`mutation delete_dental_professional_addresses_by_pk($id: uuid!){
  delete_dental_professional_addresses_by_pk(id: $id){
    id
  }
}`;

const deleteDentalPracticeAddressesByPkMutation = gql`mutation delete_dental_practice_addresses_by_pk($id: uuid!){
  delete_dental_practice_addresses_by_pk(id: $id){
    id
  }
}`;

@Injectable({
  providedIn: 'root'
})
export class DeleteDentalSupplierAddressesByPkService {

  constructor(
    private apollo: Apollo,
    private loginService: LoginService) { }

  deleteDentalSupplierAddressesByPk(id: string){
    const loginData = this.loginService.getLoginData();
    if(loginData.type === 'SUPPLIER'){
      return this.apollo.use('external').mutate({
        mutation: deleteDentalSupplierAddressesByPkMutation,
        variables:{
          id
        }
      });
    } else if(loginData.type === 'PROFESSIONAL'){
      return this.apollo.use('external').mutate({
        mutation: deleteDentalProfessionalAddressesByPkMutation,
        variables:{
          id
        }
      });
    } else {
      return this.apollo.use('external').mutate({
        mutation: deleteDentalPracticeAddressesByPkMutation,
        variables:{
          id
        }
      });
    }
  }
}

